
import { IJetcoClaimAmountState } from './state';
import { createReducer, on, State, Action } from '@ngrx/store';
import {
  onNgrxForms, onNgrxFormsAction, SetValueAction
} from 'ngrx-forms';
import { ResponseAction } from './actions';

export const state: IJetcoClaimAmountState = {
  amount: 0
};

const reducer = createReducer(state,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, action) => {
    return state;
  }),
  on(ResponseAction, (state, { payload }) => {
    return {
      ...state,
      amount: payload
    };
  })
);

export function jetcoClaimAmountReducer(state: any | undefined, action: Action) {
  return reducer(state, action);
}
